export default "__VITE_ASSET__9700446c__"